import type { ComponentProps } from "react"
import { DialogFooter as DialogFooterBase } from "@/v2-ui/dialog/base/DialogBase"
import cn from "@/v2-ui/utils/utils.cn"

export type DialogFooterProps = ComponentProps<typeof DialogFooterBase>

function DialogFooter(props: DialogFooterProps) {
  const { className, ...dialogFooterBaseProps } = props
  return (
    <DialogFooterBase
      className={cn("ui-dialog-footer", className)}
      {...dialogFooterBaseProps}
    />
  )
}

export default DialogFooter
